'use client';
import AnimateLines from '@components/animate-lines/AnimateLines';
import gsap, { ScrollTrigger } from 'gsap/all';
import { useEffect, useRef, useState } from 'react';

import styles from '../Queue.module.scss';

gsap.registerPlugin(ScrollTrigger);

const QueueAnimationLines = ({ isMobile, isAbout }) => {
  const [toggle2, setToggle2] = useState(false);
  const [toggle3, setToggle3] = useState(false);

  const svgRef2 = useRef(null);
  const svgRef3 = useRef(null);

  useEffect(() => {
    if (svgRef2.current) {
      let st2 = null;
      const element = svgRef2.current;
      setTimeout(() => {
        st2 = ScrollTrigger.create({
          trigger: element,
          start: 'top top',
          scroller: !isMobile ? '#smooth-wrapper' : 'body',
          duration: 1,
          scrub: true,
          pin: false,
          onToggle: () => {
            setTimeout(() => {
              setToggle2(true);
            }, 400);
          },
        });
        return () => {
          st2.kill();
        };
      }, 500);
    }
  }, [svgRef2]);

  useEffect(() => {
    if (svgRef3.current) {
      let st3 = null;
      const element = svgRef3.current;
      setTimeout(() => {
        st3 = ScrollTrigger.create({
          trigger: element,
          start: 'top top',
          scroller: !isMobile ? '#smooth-wrapper' : 'body',
          duration: 1,
          scrub: true,
          pin: false,
          onToggle: () => {
            setTimeout(() => {
              setToggle3(true);
            }, 500);
          },
        });
        return () => {
          st3.kill();
        };
      }, 500);
    }
  }, [svgRef3]);

  return (
    <>
      {!isMobile && !isAbout && (
        <div className={styles.aboutDesktop} ref={svgRef2}>
          <AnimateLines id='about-desktop' className={styles.aboutDesktopSvg} toggle={toggle2} />
        </div>
      )}
      {isMobile && !isAbout && (
        <>
          <div className={styles.aboutMobile} ref={svgRef2}>
            <AnimateLines id='about-mobile' className={styles.aboutMobileSvg} toggle={toggle2} />
          </div>
          <div className={styles.aboutMobileQueue} ref={svgRef3}>
            <AnimateLines id='about-mobile-queue' className={styles.aboutMobileQueueSvg} toggle={toggle3} />
          </div>
        </>
      )}
    </>
  );
};

export default QueueAnimationLines;
